<div class="login-wrapper">
    <div class="container-fluid">
        <div class="dis-flex flex-sb flex-m m-t-50">
            <div class="roche-logo-wrapper"><img src="{{env.assetUrl}}/Roche_Logo.png"/></div>
            <div class="obp-logo-wrapper"><img src="{{env.assetUrl}}/big_logo.png"/></div>
        </div>
    </div>
    <div class="container-fluid m-t-80">
        <div class="content dis-flex flex-m">
            <div class="left-side">
                <p class="display-3 font-medium m-b-0 text-90">Outcomes Based Planning</p>
                <button class="btn primary white mt-4" (click)="ssoLogin()">Login with SSO</button>
            </div>
            <div class="right-side flex-grow-1 text-right">
                <div class=""><img src="{{env.assetUrl}}/sign_in_image.png"/></div> 
            </div>
        </div>
    </div>
</div>